export enum ClientCategorisation {
  RETAIL = 'retail',
  PROFESSIONAL = 'professional',
}

export const CLIENT_CATEGORISATIONS = [ClientCategorisation.RETAIL, ClientCategorisation.PROFESSIONAL] as const;
